// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Asset Details data
 * @export
 * @interface IAssetDetails
 */
export interface IAssetDetails {
    /**
     * The data for this item of media. Base64-encoded data, where the decoded data is in the format as specified in ‘type’
     * @type {string}
     * @memberof IAssetDetails
     */
    data: string;
    /**
     * Specified as a MIME type. image/png: includes alpha channel, image/svg+xml: image in SVG format or HTML
     * @type {string}
     * @memberof IAssetDetails
     */
    type: string;
    /**
     * For non-SVG image assets, the height of the image. Specified in pixels
     * @type {string}
     * @memberof IAssetDetails
     */
    height?: string | null;
    /**
     * For non-SVG image assets, the width of the image. Specified in pixels
     * @type {string}
     * @memberof IAssetDetails
     */
    width?: string | null;
    /**
     * Image background dark or light mode
     * @type {string}
     * @memberof IAssetDetails
     */
    is_image_darkmode?: string | null;
}

/**
 * Check if a given object implements the IAssetDetails interface.
 */
export function instanceOfIAssetDetails(value: object): value is IAssetDetails {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IAssetDetailsFromJSON(json: any): IAssetDetails {
    return IAssetDetailsFromJSONTyped(json, false);
}

export function IAssetDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAssetDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
        'type': json['type'],
        'height': json['height'] == null ? undefined : json['height'],
        'width': json['width'] == null ? undefined : json['width'],
        'is_image_darkmode': json['isImageDarkmode'] == null ? undefined : json['isImageDarkmode'],
    };
}

export function IAssetDetailsToJSON(json: any): IAssetDetails {
    return IAssetDetailsToJSONTyped(json, false);
}

export function IAssetDetailsToJSONTyped(value?: IAssetDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'type': value['type'],
        'height': value['height'],
        'width': value['width'],
        'isImageDarkmode': value['is_image_darkmode'],
    };
}

